const vcTokenInitialState = {
    vcToken: {
        loading: false,
        error: null,
        data: null
    },
};

export default vcTokenInitialState;